import { render, staticRenderFns } from "./aiShopkeeper.vue?vue&type=template&id=59f8e5e4&scoped=true"
import script from "./aiShopkeeper.vue?vue&type=script&lang=js"
export * from "./aiShopkeeper.vue?vue&type=script&lang=js"
import style0 from "./aiShopkeeper.vue?vue&type=style&index=0&id=59f8e5e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f8e5e4",
  null
  
)

export default component.exports